export const about = {
  name: "Pedro Monteiro",
  role: "Software Engineer",
  company: "Quorum Born IT",
  livesIn: "Guarda, Portugal",
  degree: "MSc, Computer Science Engineering — University of Aveiro",
  thesis: "Real-Time Weapon Detection in Surveillance Video Footage",
  traits: ["motivated", "dedicated", "innovative", "team player"],
  stack: [
    "HTML", "CSS", "JavaScript", "React", "Python", "Django",
    "ASP .NET Core 6", "Docker", "Kubernetes", "PHP", "SQL", "MySQL",
  ],
  currentlyExploring: "cybersecurity",
  linkedin: "https://www.linkedin.com/in/pedromonteiro01/",
};
